import React from 'react';
import SectionHeader from '../../components/common/SectionHeader';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SectionHeader
        title="About Us"
        subtitle="Learn more about Fex Logistics and how we deliver for you."
        breadcrumb={[{ label: 'Home', to: '/' }, { label: 'About Us' }]}
      />

      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-12">
          <div className="bg-white rounded-xl shadow p-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Who We Are</h2>
            <p className="text-gray-700">
              Fex Logistics is a customer-first delivery company providing reliable, affordable and
              transparent logistics services. We combine modern technology with experienced teams to
              ensure packages are handled with care from pickup to delivery.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow p-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Our Mission</h2>
            <p className="text-gray-700">
              To make shipping simple and dependable for individuals and businesses by offering
              real-time tracking, clear pricing and responsive support across local, interstate and
              international routes.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white rounded-xl shadow p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Reliability</h3>
            <p className="text-gray-700">On-time pickups and deliveries with live status updates.</p>
          </div>
          <div className="bg-white rounded-xl shadow p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Transparency</h3>
            <p className="text-gray-700">Clear pricing and easy-to-understand shipment tracking.</p>
          </div>
          <div className="bg-white rounded-xl shadow p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Support</h3>
            <p className="text-gray-700">Helpful team available to assist at every step.</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow p-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 className="text-xl font-bold text-gray-900">Ready to ship?</h2>
              <p className="text-gray-700">Get a quote or contact us for custom logistics needs.</p>
            </div>
            <div className="flex items-center gap-3">
              <Link to="/quote" className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">
                Get a Quote
              </Link>
              <Link to="/contact" className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
